// import { OperationReportForm3Container } from "../../../containers/SupportSystem/OperationReportForm/OperationReportForm3Container"
// import { AdminCheckOperationReportComponent } from "../../../components/SupportSystem/OperationReportForm/AdminCheckOperationReportComponent"
import { AdminCheckOperationReportsContainer } from "../../../containers/SupportSystem/OperationReportForm/AdminCheckOperationReportsContainer"
export function AdminCheckOperationReportsPage () {
    return(
        <AdminCheckOperationReportsContainer/>
    )
}